import addMedicalReimbursement from './addMedicalReimbursement'
import medicalReimbursementServiceConfigs from './configs'
import getFileNameFromRef from './getFileNameFromRef'
import getMedicalReimbursementById from './getMedicalReimbursementById'
import getRespondedMedicalReimbursements from './getRespondedMedicalReimbursements'
import getUnrespondedMedicalReimbursements from './getUnrespondedMedicalReimbursements'
import setApprovalMedicalReimbursementById from './setApprovalMedicalReimbursementById'
import updateMedicalReimbursementById from './updateMedicalReimbursementById'

const MedicalReimbursementService = {
  configs: medicalReimbursementServiceConfigs,
  add: addMedicalReimbursement,
  getUnresponded: getUnrespondedMedicalReimbursements,
  getResponded: getRespondedMedicalReimbursements,
  getById: getMedicalReimbursementById,
  getFileNameFromRef,
  setApprovalById: setApprovalMedicalReimbursementById,
  update: updateMedicalReimbursementById,
}

export default MedicalReimbursementService
